<template>
    <settings-page :title="title" :description="description">
        <settings-presets
            :type="type"
            :element-type="elementType"
            :preview-text="previewText"
            :default-classes="defaultClasses"
            @input="onInput"
        />
    </settings-page>
</template>

<script>

import SettingsPage from '@/components/settings/shared/settings-page';
import SettingsPresets from '@/components/settings/preset/settings-presets';

export default {
    name: 'settings-presets-paragraph',
    components: { SettingsPage, SettingsPresets },

    data() {
        return {
            title: 'Paragraph Presets',
            description: 'This is where you define your paragraph presets. A “preset“ is a group of styles that can be be quickly added to a page element.',
            previewText: 'A parturient hac consectetur mi velit condimentum taciti libero primis tortor ullamcorper tellus blandit erat. Scelerisque facilisis adipiscing quam adipiscing amet facilisi volutpat neque condimentum ullamcorper tristique ullamcorper a ad ad etiam.',

            elementType: 'a-text-multi-line',
            type: 'paragraph',
            defaultClasses: 'f-text-black f-text-1 f-font-default f-leading-relaxed f-font-normal',
        };
    },

    methods: {
        onInput(prop, data) {
            this.$emit('input', prop, data);
        },
    },
};
</script>
